

























































































































import { Prop, Vue } from 'vue-property-decorator'
export default class Navbar extends Vue {
}
